// enrollment.component.ts

import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PortalService } from '../../../../../../services/portal.service';
import { MatSelectChange } from '@angular/material/select';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-enrollment',
  templateUrl: './enrollment.component.html',
  styleUrls: ['./enrollment.component.scss'],
})
export class EnrollmentComponent implements OnInit {
  steps: any[] = [];
  currentStep: string = 'Profile';
  currentStepNumber: number = 1;
  currentStepName: string = 'Profile';
  completedStepNumber: any = 1;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private portalService: PortalService
  ) { }

  ngOnInit(): void {
    localStorage.setItem('newEnrollment','true');
    this.completedStepNumber = localStorage.getItem('CurrentEnrollmentStep');
    this.portalService.getEnrollmentSteps(environment.programID).subscribe(
      (data: any[]) => {
        // Filter and sort steps by sequence number
        this.steps = data
          .filter(step => step.enrollmentRoute !== 'N/A' && step.sequenceNumber !== 'N/A')
          .sort((a, b) => +a.sequenceNumber - +b.sequenceNumber)
          .map((step, index) => ({
            ...step,
            enrollmentRoute: step.enrollmentRoute.replace('/', ''),
            sequence: index + 1
          }));

        const initialStep = this.route.snapshot.firstChild?.url[0]?.path || 'Profile';
        this.setCurrentStep(initialStep);

      },
      error => {
        console.error('Error fetching enrollment steps:', error);
      }
    );
    this.portalService.getContentAttestionConsentType();
    this.isFirstStep();
  }

  // onStepChange(event: MatSelectChange): void {
  //   const selectedStep = event.value;
  //   this.setCurrentStep(selectedStep);
  // }

  // setCurrentStep(stepRoute: string): void {
  //   const step = this.steps.find(s => s.enrollmentRoute === stepRoute);
  //   if (step) {
  //     this.currentStep = step.enrollmentRoute;
  //     this.currentStepNumber = step.sequence;
  //     this.currentStepName = step.enrollmentStepName;
  //     this.router.navigate([step.enrollmentRoute], { relativeTo: this.route });
  //   }
  // }
  
  onStepChange(event: MatSelectChange): void {
    const selectedStep = event.value;
    const step = this.steps.find(s => s.enrollmentRoute === selectedStep);
    this.setCurrentStep(selectedStep);
  }
  
  setCurrentStep(stepRoute: string, route = ""): void {
    const step = this.steps.find(s => s.enrollmentRoute === stepRoute);
    if (step) {
      localStorage.setItem('CurrentEnrollmentStep', step.sequence);
      this.currentStep = step.enrollmentRoute;
      this.currentStepNumber = step.sequence;
      this.currentStepName = step.enrollmentStepName;
      if(this.currentStepNumber > this.completedStepNumber){
        this.completedStepNumber = this.currentStepNumber
      }

      this.updateStepAvailability(); // Update disabled state
      // // { relativeTo: this.route }
      if (route !== "") {
        //this.router.navigate([route || step.enrollmentRoute],{ relativeTo: this.route });
      } else {
        this.router.navigate([step.enrollmentRoute], { relativeTo: this.route });
      }
    }
  }
  
  setCurrentStepEditflow(){
    this.completedStepNumber = localStorage.getItem('CurrentEnrollmentStep');
    this.updateStepAvailability();
  }

  updateStepAvailability(): void {
    this.steps.forEach(step => {
      step.disabled = step.sequence > this.completedStepNumber;
    });
  }
  

  goBack(): void {
    this.isFirstStep();
    const currentIndex = this.steps.findIndex(step => step.enrollmentRoute === this.currentStep);
    if (currentIndex > 0) {
      const previousStep = this.steps[currentIndex - 1];
      this.setCurrentStep(previousStep.enrollmentRoute);
      
    }
  }
  isFirstStep(): boolean {
    const currentIndex = this.steps.findIndex(step => step.enrollmentRoute === this.currentStep);
    return currentIndex === 0;
  }
}
